import classnames from 'classnames/bind'
import { GlobalThemeColors } from '~/@types/colors'
import { GlobalTextPreset } from '~/@types/text-preset'
import { GlobalTextStyling } from '~/@types/text-styling'

import { UnlikelyMoney } from '@unlikelystudio/commerce-connector'

import Link from '~/components/Abstracts/Link'
import Image, { ImageProps } from '~/components/UI/Image'

import { useStyle } from '~/providers/StyleProvider'

import useLocale from '~/hooks/useLocale'

import serializePrice from '~/data/serialize-price'

import css from './styles.module.scss'

const cx = classnames.bind(css)

const IMAGE_SIZES = [
  {
    breakpoint: 'lg',
    ratio: 3 / 12,
  },
  { ratio: 2 / 6 },
]

export interface ReviewHeaderProps {
  className?: string
  image?: ImageProps
  title?: string
  subtitle?: string
  link?: string
  price?: UnlikelyMoney
}

function ReviewHeader({
  className,
  title,
  subtitle,
  image,
  link,
  price,
}: ReviewHeaderProps) {
  const locale = useLocale()
  const productTitleStyle = useStyle({
    textPreset: GlobalTextPreset.Title12Primary,
    textStyling: GlobalTextStyling.UpperCase,
  })

  const subTitleStyle = useStyle({
    textPreset: GlobalTextPreset.Text12Secondary,
    color: GlobalThemeColors.Gray1ToBlack,
  })

  const priceStyle = useStyle({
    textPreset: GlobalTextPreset.Text12Secondary,
  })

  const borderColor = useStyle({
    borderColor: GlobalThemeColors.Gray3ToBlack,
  })

  const Product = (
    <div className={cx(css.productContainer)}>
      {image && (
        <div className={cx(css.imageContainer)}>
          <Image
            className={cx(css.image)}
            sizesFromBreakpoints={IMAGE_SIZES}
            layout="fill"
            priority={true}
            objectFit="cover"
            ratio={0.75}
            {...image}
          />
        </div>
      )}
      <div className={cx(css.content)}>
        {title && <h2 className={cx(css.title, productTitleStyle)}>{title}</h2>}
        {subtitle && (
          <h5 className={cx(css.title, subTitleStyle)}>{subtitle}</h5>
        )}
        {price && (
          <h5 className={cx(css.price, priceStyle)}>
            {serializePrice(locale, price.currencyCode, price.amount)}
          </h5>
        )}
      </div>
    </div>
  )

  return (
    <div className={cx(css.ReviewHeader, className, borderColor)}>
      {link ? <Link href={link}>{Product}</Link> : Product}
    </div>
  )
}

ReviewHeader.defaultProps = {}

export default ReviewHeader
